import { getCurrentLocale } from 'easit--localization';
import { StatisticsInApi, StatisticsType } from 'eTip--common';

export function addRelativeUrl(a: string, b: string): string {
    let aParts = a.split('/').filter(part => part != '');
    const bParts = b.split('/').filter(part => part != '');
    for (let bPart of bParts) {
        if (bPart == '') continue;
        if (bPart == '..') {
            aParts.length--;
        }
        else {
            aParts.push(bPart);
        }
    }

    return '/' + aParts.join('/');
}

export const getStatsUrl = (statistics: StatisticsInApi): string => {
    let customerKey = __IsMTSTipos__ ? "tipos" : "synottip";
    if (statistics) {
        if (statistics.type === StatisticsType.BRMatch) {
            return `https://s5.sir.sportradar.com/${customerKey}/${getCurrentLocale()}/match/${statistics.id}`;
        } else if (statistics.type === StatisticsType.BRStage) {
            return `https://s5.sir.sportradar.com/${customerKey}/${getCurrentLocale()}/stage/${statistics.id}`;
        } else {
            throw new Error("Unexpected stats type " + statistics.type);
        }

    } else {
        return `https://s5.sir.sportradar.com/${customerKey}/${getCurrentLocale()}/`;
    }
}